import ButtonComponent from 'components/ButtonComponent';
import { getPostalsUpdateDate, updatePostals } from 'lib/communication/postal';
import _, { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';

const Postals = () => {
    const [files, setFiles] = useState<File[]>();
    const [message, setMessage] = useState<string>('Proszę wybrać pliki.');
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [lastUpdateDate, setLastUpdateDate] = useState('');
    const handleUploadFile = async () => {
        if (files) {
            setIsUploading(true);
            setMessage('Aktualizacja w toku, proszę czekać.');
            const response = await updatePostals(files);
            setIsUploading(false);
            setMessage(response);
        }
    };

    const setNewFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newFiles: File[] = [];

        _.map(e.target.files, (f) => {
            newFiles.push(new File([f], f.name));
        });

        setFiles(newFiles);
    };

    useEffect(() => {
        const loadLastUpdateDate = async () => {
            const date = await getPostalsUpdateDate();
            setLastUpdateDate(isEmpty(date) ? 'brak' : date);
        };
        loadLastUpdateDate();
    });

    return (
        <div>
            <h2>Aktualizacja bazy kodów pocztowych</h2>
            <p>Ostatnia aktualizacja: {lastUpdateDate} </p>
            <div style={{ fontStyle: 'italic', marginRight: 'auto', textAlign: 'start' }}>
                <p style={{ marginLeft: '25%', marginRight: '25%' }}>
                    Aby zaktualizować bazę kodów pocztowych, należy przesłać plik/pliki w odpowiednim formacie.<br /><br />

                    FORMAT PLIKÓW: <br />
                    - rozszerzenie .txt lub .csv,<br />
                    - w pierwszej linii nagłówek: PNA;MIEJSCOWOŚĆ;ULICA;NR;GMINA;POWIAT;WOJEWÓDZTWO,<br />
                    - następne linie powinny zawierać dane odpowiadające pozycjom z nagłówka, rozdzielone znakiem ';',<br />
                    - każdy plik powinien kończyć się pustą linią.<br /><br />

                    Przykład:<br /><br />

                    PNA;MIEJSCOWOŚĆ;ULICA;NR;GMINA;POWIAT;WOJEWÓDZTWO<br />
                    01-234;Warszawa;Marszałkowska;82;Warszawa;Warszawa;mazowieckie<br />
                    56-789;Kraków;F. Chopina;2;Kraków;Kraków;małopolskie
                </p>
                {' '}
            </div>
            <br />
            <input type='file' onChange={setNewFiles} accept='.txt, .csv' multiple />
            <br />
            <br />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', height: '20px' }}>
                {message}
                {isUploading && <Spinner animation='border' />}
            </div>
            <br />
            <ButtonComponent
                text='Aktualizuj'
                onClick={handleUploadFile}
                margin='0.25rem'
                onHoverAnimation={3}
                disabled={!files}
            />
        </div>
    );
};

export default Postals;
